<script setup lang="ts">
const props = defineProps<{
  page: number
  itemsPerPage: number
  totalItems: number
}>()

const emit = defineEmits<{
  'update:page': [value: number]
}>()

const safeItemsPerPage = computed(() =>
  props.itemsPerPage > 0 ? props.itemsPerPage : 1,
)
const pageCount = computed(() =>
  Math.max(1, Math.ceil(props.totalItems / safeItemsPerPage.value)),
)
const safePage = computed(() =>
  Math.min(Math.max(1, props.page), pageCount.value),
)

const start = computed(() => {
  if (props.totalItems === 0) return 0
  return (safePage.value - 1) * safeItemsPerPage.value + 1
})

const end = computed(() =>
  Math.min(safePage.value * safeItemsPerPage.value, props.totalItems),
)

const isFirstPage = computed(() => safePage.value <= 1)
const isLastPage = computed(() => safePage.value >= pageCount.value)

function setPage(value: number) {
  const next = Math.min(Math.max(1, value), pageCount.value)
  emit('update:page', next)
}
</script>

<template>
  <nav class="app-pagination" aria-label="Sidnavigering">
    <p class="app-pagination__meta">
      Visar {{ start }}-{{ end }} av {{ totalItems }}
    </p>

    <div class="app-pagination__controls">
      <button
        type="button"
        class="app-pagination__btn"
        :disabled="isFirstPage"
        aria-label="Första sidan"
        @click="setPage(1)"
      >
        <<
      </button>

      <button
        type="button"
        class="app-pagination__btn"
        :disabled="isFirstPage"
        aria-label="Föregående sida"
        @click="setPage(safePage - 1)"
      >
        <
      </button>

      <span class="app-pagination__page">
        Sida {{ safePage }} av {{ pageCount }}
      </span>

      <button
        type="button"
        class="app-pagination__btn"
        :disabled="isLastPage"
        aria-label="Nästa sida"
        @click="setPage(safePage + 1)"
      >
        >
      </button>

      <button
        type="button"
        class="app-pagination__btn"
        :disabled="isLastPage"
        aria-label="Sista sidan"
        @click="setPage(pageCount)"
      >
        >>
      </button>
    </div>
  </nav>
</template>
